import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postMessageToUser } from '../../../api/messenger';

import { REQUEST } from '../../../constants/request';

export const sendMessageToUser = createAsyncThunk(
  'messenger/sendMessageToUser',
  async ({ chatId, userId, message, type }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await postMessageToUser(
        { userId, chatId, message, type },
        {
          cancelToken: source.token,
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (arg, { getState }) => {
      const currentLoading =
        getState().messenger.currentLoadings?.[
          `${arg.userId}/sendMessageToUser`
        ] || REQUEST.idle;

      return currentLoading !== REQUEST.pending;
    },
  },
);

export const sendMessageToUserExtraReducers = builder => {
  builder
    .addCase(sendMessageToUser.pending, (state, { meta }) => {
      const userId = meta.arg;
      state.currentLoadings[`${userId}/sendMessageToUser`] = REQUEST.pending;
      state.currentRequestIds[`${userId}/sendMessageToUser`] = meta.requestId;
    })
    .addCase(sendMessageToUser.fulfilled, (state, { meta }) => {
      const userId = meta.arg;
      state.currentLoadings[`${userId}/sendMessageToUser`] = REQUEST.idle;
      state.currentRequestIds[`${userId}/sendMessageToUser`] = undefined;
    })
    .addCase(sendMessageToUser.rejected, (state, { meta, payload }) => {
      const userId = meta.arg;
      state.currentLoadings[`${userId}/sendMessageToUser`] = REQUEST.idle;
      state.currentRequestIds[`${userId}/sendMessageToUser`] = undefined;
      state.currentErrors[`${userId}/sendMessageToUser`] = payload;
    });
};
